/**
 * DIOLYSH: PDP accordion — only one row (Description / Care / Specifications) open
 * at a time (2026-09-04 fix). Opening one row closes any other open row in the
 * same accordion.
 *
 * Scoped via a substring match on the accordion's block key ('accordion_NKWPiW',
 * see templates/product.json) rather than an exact class match, because Shopify
 * renders the block's class as `accordion--<section-render-hash>__accordion_NKWPiW`
 * — the hash prefix is added at render time, so an exact '.accordion--accordion_NKWPiW'
 * selector never matches and this script silently never ran. Using [class*="..."]
 * matches regardless of that prefix.
 *
 * The native <details> `toggle` event doesn't bubble, so this listens in the
 * capture phase at the document level to reliably catch it from any nested
 * accordion row.
 */
(function () {
  var PDP_ACCORDION_KEY = 'accordion_NKWPiW';

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      var container = details.closest('[class*="' + PDP_ACCORDION_KEY + '"]');
      if (!container) return;

      var openDetails = container.querySelectorAll('details[open]');
      for (var i = 0; i < openDetails.length; i++) {
        var other = openDetails[i];
        if (other !== details) other.open = false;
      }
    },
    true
  );
})();
